import template from './mf-select-item-tree.html';
import './mf-select-item-tree.scss';

export default {
	template,
	bindings: {
		index: '<',
		path:  '<ngModel',
		tree:  '<',
	},
	require:  {
		ngModelCtrl: 'ngModel',
	},
};
